import endpoints from "../data/endpoints";
import { ProductDataResponse, ProductDataResult } from "../types/types";
import apiRequest from "./apiRequest";

export const fetchProductData = async (
	series: string[],
): Promise<ProductDataResult> => {
	const response = (await apiRequest(endpoints.productData.url, {
		method: endpoints.productData.requestMethod,
		body: JSON.stringify({ series }),
	})) as ProductDataResponse;

	return {
		products: response.data?.products ?? [],
		seriesUrls: response.data?.seriesUrls ?? {},
		seriesImages: response.data?.seriesImages ?? {},
	};
};
